module.exports = __webpack_public_path__ + "img/icon_list_download_normal.8f3487da.svg";